export interface TagProduto {
  nome: string;
  cor: string;
}

/** Mesmas categorias e cores usadas nas tags de produto da Viniko. A ordem importa: a primeira que bater vence. */
const REGRAS: [RegExp, TagProduto][] = [
  [/moto/, { nome: 'Troca Moto', cor: '#8b5cf6' }],
  [/correia|dentada/, { nome: 'Correia Dentada', cor: '#c3cc7a' }],
  [/troca|[óo]leo/, { nome: 'Troca de Óleo', cor: '#343a46' }],
  [/hot.?stamp|\bhot\b/, { nome: 'Hot-Stamp', cor: '#f012d0' }],
  [/void/, { nome: 'VOID', cor: '#bdb3b3' }],
  [/hologr/, { nome: 'Holográfico', cor: '#5a10f0' }],
  [/\b3m\b/, { nome: '3M', cor: '#e2382f' }],
  [/\bap\b/, { nome: 'AP', cor: '#7cf02a' }],
  [/lacre|casca|\bovo\b|destrut/, { nome: 'Lacre', cor: '#3366dd' }],
  [/acr[íi]lic|espelh/, { nome: 'Acrílico', cor: '#c7b6f5' }],
  [/tecido|camiseta|uniforme|ecobag|estampa/, { nome: 'Silk (Tecido)', cor: '#8c2b2b' }],
  [/silk|serigraf/, { nome: 'Silk', cor: '#f5a00f' }],
  [/\buv\b/, { nome: 'UV', cor: '#12e0b4' }],
  [/transparent|sacola/, { nome: 'Vinil Transp.', cor: '#12b6f0' }],
  [/branco|vinil/, { nome: 'Vinil Branco', cor: '#bfeefa' }],
];

const ADESIVO: TagProduto = { nome: 'Adesivo', cor: '#9aa1ad' };

/** Tag do produto pra mostrar na lista (ex: "Etiqueta troca de óleo 4x2" → Troca de Óleo). */
export function tagProduto(material: string | null | undefined): TagProduto | null {
  const t = (material ?? '').toLowerCase();
  if (!t.trim()) return null;
  for (const [regra, tag] of REGRAS) if (regra.test(t)) return tag;
  return /adesivo|r[óo]tulo|etiqueta/.test(t) ? ADESIVO : null;
}
